import axios from "axios";
import { SEND_MAIL_URL } from "../../API/Api";

const SendNewMail = async (data, token) => {
    let headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };

    let response = await axios({
        method: "POST",
        baseURL: `${SEND_MAIL_URL}`,
        headers,
        data: data,
    });
    console.log(response.data);
    return response.data;
};

const MailService = {
    SendNewMail,
};

export default MailService;
